module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - ' + (_vm._.isEmpty(_vm.proposta) && _vm.loading.tela ? 'Carregando ...' : (_vm.ehVisualizacao ? 'Visualizando ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '') : _vm.etapa + ' da Alteração ' + (!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : '')))
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('span', {
    staticClass: "col-md-5"
  }, [(_vm._.isEmpty(_vm.proposta) && _vm.loading.tela) ? _c('span', [_vm._v("Carregando projeto ...")]) : _c('span', [(_vm.ehVisualizacao) ? _c('span', [_vm._v("Visualizar " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))]) : _c('span', [_vm._v(_vm._s(_vm.etapa) + " da Alteração em Projeto " + _vm._s(!_vm._.isNull(_vm.id) ? 'ID ' + _vm.id : ''))])])]), _vm._v(" "), (!_vm.loading.tela || _vm.ehVisualizacao) ? _c('span', {
    staticClass: "col-md-4 bloco_botoes"
  }, [_c('span', [_c('g-button-moema', {
    attrs: {
      "color": "warning",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar")])], 1), _vm._v(" "), ((!_vm._.isEmpty(_vm.proposta) || !_vm._.isNull(_vm.id)) && !_vm.ehVisualizacao) ? _c('span', [(true && _vm.erroCronograma === false) ? _c('g-button-moema', {
    attrs: {
      "color": "primary",
      "type": "button"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processarSolicitacao('SALVAR')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]) : _vm._e(), _vm._v(" "), (!_vm.loading.poderes && _vm._.includes(_vm.poderes, 'PERMITE_CONCLUIR') && _vm.erroCronograma === false) ? _c('span', [_c('g-button-moema', {
    attrs: {
      "color": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processarSolicitacao('ENCAMINHAR')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")])], 1) : (_vm.loading.poderes) ? _c('span', [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), ((!_vm._.isEmpty(_vm.proposta) || !_vm._.isNull(_vm.id)) && _vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa) && _vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', [_c('div', {
    staticClass: "btn-group dropdown"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('g-button-ujarak', {
    attrs: {
      "color": "dark-primary",
      "size": "button--size-ss",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-print",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Relatórios "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.emitir(219)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" 219 - Adiantamento de Projetos")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.emitir(222)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" 222 - Extrato de Projetos Analítico")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.emitir(248)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" 248 - Monitoramento Administrativo")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.emitir(268)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" 268 - Relatório de Ocorrências")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.emitir(300)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" 300 - Extrato de Projetos por Beneficiária")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": 'alteracoesprojeto/sumula/' + _vm.id,
      "target": "_blank"
    }
  }, [_vm._v("Visualizar Sumula")])])])], 1)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.loading.tela && !_vm.ehVisualizacao && ((_vm.usuarioLogado.userType === 'ENTIDADE' && _vm._.includes(['Solicitação'], _vm.etapa)) || (_vm.usuarioLogado.userType === 'FUNDACAO' && _vm._.includes(['8600', '8603', '8612', '8613', '8620', '8618', '8622'], _vm._.get(this.usuarioLogado, 'dadosBB.cod_comissao', ''))))) ? _c('span', {
    staticClass: "col-md-3 bloco_botoes"
  }, [_c('g-button-moema', {
    attrs: {
      "color": "error",
      "onclick": "alertaCancelamentoDialog.showModal()",
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cancelar processo")])], 1) : _vm._e(), _vm._v(" "), ((!_vm.loading.tela || _vm.ehVisualizacao) && !_vm._.isEmpty(_vm.sumarioQtdeAlteracoes)) ? _c('span', {
    staticClass: "col-md-3",
    staticStyle: {
      "margin": "7px 0px",
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('solicitacao')
      }
    }
  }, [(_vm.opcoesVisualizacao.solicitacao.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'total')) + " " + _vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'total') > 1 ? 'modificações' : 'modificação'))])]) : (_vm.opcoesVisualizacao.solicitacao.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'exclusao')) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'exclusao')) + " " + _vm._s((_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'exclusao') > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'inclusao')) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'inclusao')) + " " + _vm._s((_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'inclusao') > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'alteracao')) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'alteracao')) + " " + _vm._s((_vm._.sumBy(_vm._.values(_vm.sumarioQtdeAlteracoes), 'alteracao') > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (!_vm._.isEmpty(_vm.msgErroProcessamento)) ? _c('span', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large',
        delay: [1000, 0]
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large', delay: [1000, 0]}"
    }],
    staticClass: "icon iconeAlerta pulsingAlerta",
    attrs: {
      "title": '<h5>Mensagens de erro e alertas mais recentes</h5>'
    },
    on: {
      "click": function($event) {
        _vm.$dialog.alert('<p>' + _vm._.join(_vm.msgErroProcessamento, '</p>'), {
          html: true,
          animation: 'fade',
          customClass: 'avisoAlerta'
        }).then(function(dialog) {})
      }
    }
  }, [_c('span', [_vm._v("!")])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [(_vm._.isEmpty(_vm.proposta) && _vm._.isNull(_vm.id) && _vm.ehVisualizacao && _vm.loading.tela) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-body",
    staticStyle: {
      "height": "200px"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm._.isEmpty(_vm.proposta) && _vm._.isNull(_vm.id) && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "listaProjetos"
    }
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.listaProjetos.length === 0),
      expression: "listaProjetos.length === 0"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('span', {
    ref: "listaProjetosAlteraveis"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaProjetos.validos,
      "disabled": _vm.ehVisualizacao,
      "multiple": false,
      "placeholder": "Selecione um projeto",
      "track-by": "ds_codigo_projeto_erp",
      "label": "ds_nome",
      "custom-label": function (option) {
        return ("" + (option.ds_codigo_projeto_erp + option.ds_nome + option.ds_situacao_erp))
      },
      "preselect-first": false,
      "close-on-select": true,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "projeto"
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome))]
      }
    }, {
      key: "singleLabel",
      fn: function(props) {
        return [_c('span', {
          staticClass: "identificadorIDProjeto"
        }, [_vm._v(_vm._s(props.option.ds_codigo_projeto_erp))]), _vm._v(" " + _vm._s(props.option.ds_nome))]
      }
    }], null, false, 1965450868),
    model: {
      value: (_vm.projeto),
      callback: function($$v) {
        _vm.projeto = $$v
      },
      expression: "projeto"
    }
  }, [_vm._v(" "), _vm._v(" "), _c('template', {
    slot: "noResult"
  }, [_vm._v("Nenhum projeto localizado!")])], 2)], 1)])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.propostaBackup) || !_vm._.isNull(_vm.id)) ? _c('div', {
    staticClass: "row",
    attrs: {
      "id": "alteracao_projeto"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("\n              " + _vm._s(_vm.propostaBackup.ds_codigo_projeto_erp) + " - " + _vm._s(_vm.propostaBackup.ds_nome) + "\n              "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.loading.tela) ? _c('span', [_vm._v("("), _c('strong', [_vm._v(_vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.sitprj', '')))]), _vm._v(")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Objetivo Geral:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm.propostaBackup.ds_objetivo_geral))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Período de execução:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.propostaBackup.dt_assinatura_convenio, "L")) + " a " + _vm._s(_vm.dataFinalBackup))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Nome da Instituição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.entidadeParceira.nomfor', '')) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valor do projeto:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
    return _vm._.includes(['1', '5'], ('' + i.origem).substr(0, 1))
  }), 'valor_total')))))])]), _vm._v(" "), _c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Valor de contrapartida:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._f("real")(_vm._.sumBy(_vm._.map(_vm._.filter(_vm._.flatten(_vm._.map(_vm.propostaBackup.atividades, 'itens_orcamentos')), function(i) {
    return _vm._.includes(['2'], ('' + i.origem).substr(0, 1))
  }), 'valor_total')))))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Municipios atendidos:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control-static"
  }, [_vm._v(_vm._s(_vm._.join(_vm._.uniq(_vm._.map(_vm.propostaBackup.municipalizacao, function(m) {
    return m.ds_municipio + (_vm._.isNil(m.ds_uf) ? '' : ' (' + m.ds_uf + ')')
  })), ', ')))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Projeto superior:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('div', {
    staticClass: "form-control-static truncar"
  }, [_vm._v(_vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.projetoSuperior.numprj', '')) + " - " + _vm._s(_vm._.get(_vm.propostaBackup, 'projetoSapiens.projetoSuperior.nomprj', '')))])])]), _vm._v(" "), _c('div', {
    ref: "justificativa",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Qual a justificativa para esta solicitação de alteração de projeto",
      "min-height": 72,
      "autosize": true,
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "name": "justificativa",
      "rows": "3"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.solicitacao.justificativa),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao, "justificativa", $$v)
      },
      expression: "solicitacao.justificativa"
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [(_vm._.get(_vm.ultimaTarefa, 'observacao', false)) ? _c('div', {
    staticClass: "alert alert-info alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.ultimaTarefa.observacao)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.restricaoParaInicializar.length > 0) ? _c('div', {
    staticClass: "alert alert-warning alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm._.uniq(_vm.restricaoParaInicializar)), function(restricao) {
    return _c('p', [_vm._v(_vm._s(restricao))])
  })], 2) : _vm._e(), _vm._v(" "), (!_vm.ehVisualizacao && _vm.usuarioLogado.userType !== 'FUNDACAO') ? _c('div', {
    staticClass: "alert alert-info alert-dismissible"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-hidden": "true"
    }
  }, [_vm._v("×")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v("As alterações solicitadas podem gerar aditivo para assinatura futura")])]) : _vm._e()])])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.proposta) && _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('div', {
    staticClass: "row box-header",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.solicitacao = !_vm.mostrar.solicitacao
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.solicitacao ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar Solicitação")])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.proposta)) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrar.solicitacao),
      expression: "mostrar.solicitacao"
    }],
    staticClass: "form-horizontal"
  }, [(_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PERIODO_PROJETO') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'periodoProjeto') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', [_c('div', {
    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PERIODO_PROJETO') ? 'bloco_com_alteracao' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        return _vm.alterarExpandirBloco('periodo')
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.periodo.expandir ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Período de execução do projeto")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PERIODO_PROJETO')) ? _c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('periodo')
      }
    }
  }, [(_vm.opcoesVisualizacao.periodo.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.periodo.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'exclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'inclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'alteracao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PERIODO_PROJETO', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.opcoesVisualizacao.periodo.expandir) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data inicial")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.proposta.dt_assinatura_convenio, "L")))])])]), _vm._v(" "), _c('div', {
    staticClass: "required-field col-md-4 required",
    class: {
      'has-error': _vm.errors.first('periodo')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses do projeto")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "inline-table"
    }
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.nr_periodos),
      expression: "proposta.nr_periodos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.projetoPeriodos + '|max_value:' + _vm.proposta.periodo_vigencia),
      expression: "'required|min_value:' + projetoPeriodos + '|max_value:' + proposta.periodo_vigencia"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Número de Meses do Projeto",
      "lang": "pt-br",
      "name": "periodo",
      "type": "number",
      "min": "1",
      "max": _vm.proposta.periodo_vigencia,
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)
    },
    domProps: {
      "value": (_vm.proposta.nr_periodos)
    },
    on: {
      "blur": function($event) {
        return _vm.prepararSolicitacao()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "nr_periodos", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.opcoesVisualizacao.periodo.modificacoes === 'DETALHADO' && _vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.nr_periodos.0')) ? _c('span', {
    staticClass: "input-group-addon valorAlterado",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.nr_periodos.0', 0)) + "\n                      ")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('periodo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodo')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data final de execução")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm.dataFinal))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-4"
  }), _vm._v(" "), _c('div', {
    staticClass: "required-field col-md-4 required",
    class: {
      'has-error': _vm.errors.first('periodoVigencia')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número de meses de Vigência")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "display": "inline-table"
    }
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.proposta.periodo_vigencia),
      expression: "proposta.periodo_vigencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min_value:' + _vm.proposta.nr_periodos),
      expression: "'required|min_value:' + proposta.nr_periodos"
    }],
    staticClass: "form-control",
    attrs: {
      "data-vv-as": "Período Vigência",
      "lang": "pt-br",
      "name": "periodoVigencia",
      "type": "number",
      "max": "72",
      "min": _vm.proposta.nr_periodos,
      "disabled": _vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)
    },
    domProps: {
      "value": (_vm.proposta.periodo_vigencia)
    },
    on: {
      "blur": function($event) {
        return _vm.prepararSolicitacao()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.proposta, "periodo_vigencia", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.opcoesVisualizacao.periodo.modificacoes === 'DETALHADO' && _vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.periodo_vigencia.0')) ? _c('span', {
    staticClass: "input-group-addon valorAlterado",
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n                      " + _vm._s(_vm._.get(_vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PERIODO_PROJETO']), 'alteracao.0.periodo_vigencia.0', 0)) + "\n                    ")]) : _vm._e()]), _vm._v(" "), (_vm.errors.first('periodoVigencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('periodoVigencia')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Data final da vigência")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-control",
    attrs: {
      "disabled": "disabled"
    }
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dataFinalVigencia, "L")))])])])])]), _vm._v(" "), (('' + _vm.proposta.nr_periodos) !== ('' + _vm.propostaBackup.nr_periodos) && _vm._.includes(['Análise', 'Autorização'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "col-md-3 text-red"
  }, [_vm._v("\n              Atenção: o período foi alterado!"), _c('br'), _vm._v("Passou de " + _vm._s(_vm.propostaBackup.nr_periodos) + " meses para " + _vm._s(_vm.proposta.nr_periodos) + " meses"), _c('br'), _c('br'), _vm._v("\n              Verifique se as atividades estão de acordo com o novo período.\n            ")]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.proposta, 'historicos.periodos')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('br'), _vm._v(" "), (_vm.loading.historicos.periodos) ? _c('span', [_vm._m(3)]) : _c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.historicos.periodos = !_vm.mostrar.historicos.periodos
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.historicos.periodos ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Histórico de alterações de término do projeto\n              ")]), _vm._v(" "), (_vm.mostrar.historicos.periodos) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "stacked": "md",
      "items": _vm.proposta.historicos.periodos,
      "bordered": _vm.tabela.historicos.periodos.bordered,
      "fields": _vm.tabela.historicos.periodos.fields
    },
    scopedSlots: _vm._u([{
      key: "id",
      fn: function(row) {
        return [_vm._v(_vm._s(row.value))]
      }
    }, {
      key: "acao",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))]
      }
    }, {
      key: "periodo",
      fn: function(row) {
        return [(row.item.acao === 'Contratação') ? _c('span', [_vm._v(_vm._s(row.item.periodo_inicial) + " meses")]) : _c('span', {
          staticClass: "text-muted"
        }, [_c('span', {
          staticClass: "text-green"
        }, [_vm._v(_vm._s(row.item.periodo_alterado >= 0 ? '+' : '') + _vm._s(row.item.periodo_alterado))]), _vm._v(" para " + _vm._s(row.item.periodo_final) + " meses\n                      ")])]
      }
    }, {
      key: "termino_alterado",
      fn: function(row) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("moment")(row.value, "L")))])]
      }
    }], null, false, 136229566)
  })], 1)], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_METAS') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'metas') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', [_c('div', {
    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_METAS') ? 'bloco_com_alteracao' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        return _vm.alterarExpandirBloco('metas')
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.metas.expandir ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Metas")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_METAS')) ? _c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('metas')
      }
    }
  }, [(_vm.opcoesVisualizacao.metas.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.metas.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'exclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'inclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'alteracao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_METAS', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.opcoesVisualizacao.metas.expandir) ? _c('div', {
    staticClass: "box-body"
  }, [_c('metas', {
    attrs: {
      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "propsObjetivos": _vm.proposta.objetivos,
      "propsMetas": _vm.proposta.metas,
      "propsProposta": _vm.proposta,
      "propsPropostaBackup": _vm.propostaBackup,
      "atvSemMetas": _vm.atvSemMetas,
      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_METAS']),
      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.metas.modificacoes
    },
    on: {
      "acaoAtualizaSolicitacoes": function($event) {
        return _vm.prepararSolicitacao()
      },
      "metaAdicionada": function($event) {
        _vm.proposta.metas = $event
      },
      "validacaoMetas": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_ATIVIDADES') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'atividades') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', {
    ref: "atividades"
  }, [_c('div', {
    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_ATIVIDADES') ? 'bloco_com_alteracao' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        return _vm.alterarExpandirBloco('atividades')
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.atividades.expandir ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Atividades")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_ATIVIDADES')) ? _c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('atividades')
      }
    }
  }, [(_vm.opcoesVisualizacao.atividades.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.atividades.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'exclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'inclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'alteracao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_ATIVIDADES', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.opcoesVisualizacao.atividades.expandir) ? _c('div', {
    staticClass: "box-body"
  }, [_c('atividades', {
    attrs: {
      "novaAtividade": _vm.criarAtividade,
      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "meses": _vm.proposta.nr_periodos,
      "propsMetas": _vm.proposta.metas,
      "propsAtividades": _vm.proposta.atividades,
      "propsProposta": _vm.proposta,
      "propsPropostaBackup": _vm.propostaBackup,
      "atualizar": _vm.numeroAtualizacao,
      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_ATIVIDADES']),
      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.atividades.modificacoes
    },
    on: {
      "acaoAtualizaSolicitacoes": function($event) {
        return _vm.prepararSolicitacao()
      },
      "atividadeAdicionada": function($event) {
        _vm.proposta.atividades = $event
      },
      "validacaoAtividades": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), ((_vm._.has(_vm.sumarioQtdeAlteracoes, 'REMANEJAMENTO') || _vm._.has(_vm.sumarioQtdeAlteracoes, 'SUPLEMENTACAO') || (_vm._.intersection(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), ['remanejamento', 'suplementacao'])).length > 0 && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))) ? _c('div', [_c('div', {
    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'REMANEJAMENTO') || _vm._.has(_vm.sumarioQtdeAlteracoes, 'SUPLEMENTACAO') ? 'bloco_com_alteracao' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block",
      "z-index": "700"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        return _vm.alterarExpandirBloco('extratoProjeto')
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.extratoProjeto.expandir ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Extrato do cronograma")]), _vm._v(" "), _c('span', [(_vm.ehVisualizacao || _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', {
    staticClass: "text-blue"
  }, [_vm._v("\n                    " + _vm._s(_vm.tipoAlteracaoCronograma === 'REMANEJAMENTO' ? 'Remanejamento' : 'Suplementação') + "\n                  ")]) : _c('span', [((_vm._.intersection(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), ['remanejamento', 'suplementacao'])).length > 1) ? _c('span', [_c('span', {
    staticStyle: {
      "font-size": "small",
      "color": "var(--cor-fraca-dark)"
    }
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "new-control new-control-radio",
    style: ('padding-top: 10px;' + (_vm.tipoAlteracaoCronograma === 'REMANEJAMENTO' ? 'color: var(--cor-azul);' : '')),
    attrs: {
      "title": '<h5>Remanejamento permite alterar o cronograma aumentando e subtraindo valores desde que a soma final seja zero</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoAlteracaoCronograma),
      expression: "tipoAlteracaoCronograma"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoAlteracaoCronograma"
    },
    domProps: {
      "value": 'REMANEJAMENTO',
      "checked": _vm._q(_vm.tipoAlteracaoCronograma, 'REMANEJAMENTO')
    },
    on: {
      "change": function($event) {
        _vm.tipoAlteracaoCronograma = 'REMANEJAMENTO'
      }
    }
  }), _vm._v(" Remanejamento"), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "new-control new-control-radio",
    style: ('padding-top: 10px;' + (_vm.tipoAlteracaoCronograma === 'SUPLEMENTACAO' ? 'color: var(--cor-azul);' : '') + 'margin-left: 20px'),
    attrs: {
      "title": '<h5>Suplemetação permite aumentar o valor do projeto, aumentando orçamento de itens ou criando novos</h5>'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tipoAlteracaoCronograma),
      expression: "tipoAlteracaoCronograma"
    }],
    attrs: {
      "type": "radio",
      "name": "tipoAlteracaoCronograma"
    },
    domProps: {
      "value": 'SUPLEMENTACAO',
      "checked": _vm._q(_vm.tipoAlteracaoCronograma, 'SUPLEMENTACAO')
    },
    on: {
      "change": function($event) {
        _vm.tipoAlteracaoCronograma = 'SUPLEMENTACAO'
      }
    }
  }), _vm._v(" Suplementação"), _c('div', {
    staticClass: "new-control-indicator"
  })])])]) : _c('span')])]), _vm._v(" "), (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'suplementacao') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', {
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "small"
    }
  }, [_vm._v(_vm._s(_vm.tipoAlteracaoCronograma === 'SUPLEMENTACAO' ? 'A suplementação não deve ultrapassar 25%' : ''))]) : _vm._e(), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'REMANEJAMENTO') || _vm._.has(_vm.sumarioQtdeAlteracoes, 'SUPLEMENTACAO')) ? _c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('extratoProjeto')
      }
    }
  }, [(_vm.opcoesVisualizacao.extratoProjeto.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'total'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'total'], ''))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'total'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'total'], 0)) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.extratoProjeto.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'exclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'exclusao'], 0)) > 0) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'exclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'exclusao']))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'exclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'exclusao'], 0)) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'inclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'inclusao'], 0)) > 0) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'inclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'inclusao']))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'inclusao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'inclusao'], 0)) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'alteracao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'alteracao'], 0)) > 0) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'alteracao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'alteracao']))) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['REMANEJAMENTO', 'alteracao'], _vm._.get(_vm.sumarioQtdeAlteracoes, ['SUPLEMENTACAO', 'alteracao'], 0)) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), (_vm.opcoesVisualizacao.extratoProjeto.expandir) ? _c('div', {
    staticClass: "box-body"
  }, [_c('extrato', {
    attrs: {
      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "etapa": 'SOLICITACAO',
      "tipo-solicitacao": _vm.tipoAlteracaoCronograma,
      "layout": 'classico',
      "itensLayout": _vm.etapa === 'Análise' ? ['filtroItens', 'substituicaoItem'] : [],
      "propsObjetivos": _vm.proposta.objetivos,
      "propsAtividades": _vm.proposta.atividades,
      "metas": _vm.proposta.metas,
      "proposta": _vm.proposta,
      "meses": _vm.proposta.nr_periodos,
      "projetoDuplicacao": _vm.proposta.nr_projeto_duplicacao,
      "filtro-inicial": _vm.ehVisualizacao ? ['solicitados'] : (_vm._.includes(['REMANEJAMENTO', 'SUPLEMENTACAO'], _vm._.map(_vm.solicitacao.processos, 'nome')) && _vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa) ? ['solicitados'] : []),
      "processo-solicitacao": {
        'processo': _vm.processo,
        'solicitacao': _vm._.find(_vm.solicitacao.processos, ['nome', _vm.tipoAlteracaoCronograma])
      },
      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.extratoProjeto.modificacoes,
      "atualizar-extrato": !_vm._.includes(['FEITO', 'CANCELADO'], _vm._.get(_vm.processo, 'situacao', ''))
    },
    on: {
      "acaoOk": function($event) {
        return _vm.prepararSolicitacao()
      },
      "acaoTotaisAtualizados": function($event) {
        return _vm.passarTotaisExtratoParaSumula($event)
      },
      "cronogramaAtividades": function($event) {
        _vm.proposta.atividades = $event
      },
      "alteracoesCronograma": function($event) {
        _vm.cronogramaAlteracoes = $event
      },
      "validacaoCronograma": function($event) {
        return _vm.adicionaRestricao($event)
      },
      "criacaoAtividade": function($event) {
        _vm.criarAtividade = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('visualiza-gestao-atividades', {
    key: 'GANTT-' + _vm.numeroAtualizacao,
    attrs: {
      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "itensLayout": ['opcoes'],
      "propsNumeroProjeto": _vm.proposta.ds_codigo_projeto_erp,
      "propsAtividades": _vm.proposta.atividades,
      "atividades-alteradas": _vm.listaIdsAtividadesAlteradas,
      "proposta": _vm.proposta,
      "atualizar-gantt": !_vm._.includes(['FEITO', 'CANCELADO'], _vm._.get(_vm.processo, 'situacao', ''))
    },
    on: {
      "atividadesProposta": function($event) {
        _vm.proposta.atividades = $event
      },
      "atividadesGantt": function($event) {
        _vm.proposta.gantt_atividades = $event
      },
      "atividadesAlteracoes": function($event) {
        _vm.proposta.gantt_alterado = $event
      },
      "validacaoAtividadesGantt": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1)], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'parcelasAdiantamento') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))),
      expression: "_.has(sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO') || (_.includes(_.get(proposta, 'opcoes.alteracoesPermitidas', []), 'parcelasAdiantamento') && !ehVisualizacao && !_.includes(['Autorização', 'Deliberação', 'Pendências'], etapa))"
    }]
  }, [_c('div', {
    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO') ? 'bloco_com_alteracao' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        return _vm.alterarExpandirBloco('parcelasAdiantamento')
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.parcelasAdiantamento.expandir ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Parcelas de Adiantamento")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_PARCELAS_ADIANTAMENTO')) ? _c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('parcelasAdiantamento')
      }
    }
  }, [(_vm.opcoesVisualizacao.parcelasAdiantamento.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.parcelasAdiantamento.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'exclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'inclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'alteracao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_PARCELAS_ADIANTAMENTO', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opcoesVisualizacao.parcelasAdiantamento.expandir),
      expression: "opcoesVisualizacao.parcelasAdiantamento.expandir"
    }],
    staticClass: "box-body"
  }, [_c('parcela-adiantamento', {
    attrs: {
      "alteracaoProjeto": true,
      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "propsProposta": _vm.proposta,
      "propsPropostaBackup": _vm.propostaBackup,
      "propsParcelas": _vm._.get(_vm.proposta, 'adiantamentos', []),
      "propsLayout": 'EXECUCAO',
      "propsAtividades": _vm.proposta.atividades,
      "atualizar": _vm.numeroAtualizacao,
      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_PARCELAS_ADIANTAMENTO']),
      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.parcelasAdiantamento.modificacoes
    },
    on: {
      "acaoAtualizaSolicitacoes": function($event) {
        return _vm.prepararSolicitacao()
      },
      "parcelaAdicionada": function($event) {
        _vm.proposta.adiantamentos = $event
      },
      "validacaoParcelasAdiantamento": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS') || (_vm._.includes(_vm._.get(_vm.proposta, 'opcoes.alteracoesPermitidas', []), 'municipios') && !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa))),
      expression: "_.has(sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS') || (_.includes(_.get(proposta, 'opcoes.alteracoesPermitidas', []), 'municipios') && !ehVisualizacao && !_.includes(['Autorização', 'Deliberação', 'Pendências'], etapa))"
    }]
  }, [_c('div', {
    class: 'box box-widget ' + (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS') ? 'bloco_com_alteracao' : '')
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        return _vm.alterarExpandirBloco('municipios')
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.opcoesVisualizacao.municipios.expandir ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Municípios - Locais de execução")])]), _vm._v(" "), (_vm._.has(_vm.sumarioQtdeAlteracoes, 'ALTERACAO_MUNICIPIOS')) ? _c('span', {
    staticClass: "bloco_resumo_alteracao",
    on: {
      "click": function($event) {
        return _vm.alterarModoModificacao('municipios')
      }
    }
  }, [(_vm.opcoesVisualizacao.municipios.modificacoes === 'RESUMIDO') ? _c('span', {
    staticClass: "modificacaoResumido"
  }, [_c('span', [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'total'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'total']) > 1 ? 'modificações' : 'modificação')))])]) : (_vm.opcoesVisualizacao.municipios.modificacoes === 'DETALHADO') ? _c('span', {
    staticClass: "modificacaoDetalhado"
  }, [(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'exclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalExclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'exclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'exclusao']) > 1 ? 'exclusões' : 'exclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'inclusao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalInclusao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'inclusao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'inclusao']) > 1 ? 'inclusões' : 'inclusão')))]) : _vm._e(), _vm._v(" "), (_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'alteracao'], 0) > 0) ? _c('span', {
    staticClass: "modificacaoTotalAlteracao"
  }, [_vm._v(_vm._s(_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'alteracao'])) + " " + _vm._s((_vm._.get(_vm.sumarioQtdeAlteracoes, ['ALTERACAO_MUNICIPIOS', 'alteracao']) > 1 ? 'alterações' : 'alteração')))]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opcoesVisualizacao.municipios.expandir),
      expression: "opcoesVisualizacao.municipios.expandir"
    }],
    staticClass: "box-body"
  }, [_c('municipalizacao', {
    attrs: {
      "editavel": !_vm.ehVisualizacao && !_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa),
      "propsProposta": _vm.proposta,
      "propsPropostaBackup": _vm.propostaBackup,
      "propsLayout": _vm._.includes(['Análise'], _vm.etapa) ? ['COM_BOTOES_DISTRIBUICAO'] : ['SEM_BOTOES_DISTRIBUICAO'],
      "atualizar": _vm.numeroAtualizacao,
      "processo-solicitacao": _vm._.find(_vm.solicitacao.processos, ['nome', 'ALTERACAO_MUNICIPIOS']),
      "modo-visualizacao-alteracoes": _vm.opcoesVisualizacao.municipios.modificacoes
    },
    on: {
      "acaoAtualizaSolicitacoes": function($event) {
        return _vm.prepararSolicitacao()
      },
      "municipioAdicionado": function($event) {
        _vm.proposta.municipalizacao = $event
      },
      "validacaoMunicipio": function($event) {
        return _vm.adicionaRestricao($event)
      }
    }
  })], 1)])]), _vm._v(" "), (_vm.usuarioLogado.userType !== 'FUNDACAO' && (_vm._.includes(_vm.poderes, 'PERMITE_CONCLUIR') || !_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa))) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    ref: "instrumentosLidos",
    class: 'col-md-12 alert alert-dismissible ' + (_vm.solicitacao.instrumentosLidos.ok ? 'alert-success' : (_vm._.find(_vm.errors.items, ['field', 'instrumentosLidos']) ? 'alert-danger' : 'alert-warning')),
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    class: 'col-md-' + (!_vm._.isNull(_vm.solicitacao.instrumentosLidos.usuario) ? '8' : '12')
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "juntos"
  }, [(_vm._.includes(['Solicitação', 'Revisão'], _vm.etapa)) ? _c('span', [_c('i', {
    class: (_vm.solicitacao.instrumentosLidos.ok ? 'fa fa-check-square-o selecionado' : 'fa fa-square-o'),
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.solicitacao.instrumentosLidos.ok = !_vm.solicitacao.instrumentosLidos.ok;
        _vm._.remove(_vm.errors.items, ['field', 'instrumentosLidos'])
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    class: _vm.solicitacao.instrumentosLidos.ok ? 'selecionado' : ''
  }, [_vm._v(" Li e estou ciente das cláusulas do instrumento e seus aditivos")])])]), _vm._v(" "), (!_vm._.isNull(_vm.solicitacao.instrumentosLidos.usuario)) ? _c('div', {
    staticClass: "col-md-4 text-right"
  }, [_vm._v("\n                " + _vm._s(_vm.solicitacao.instrumentosLidos.usuario.ds_nome_usuario)), _c('br'), _vm._v("\n                " + _vm._s(_vm._f("moment")(_vm.solicitacao.instrumentosLidos.data, 'DD/MM/YYYY HH:MM:SS')) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.errors.items, ['field', 'instrumentosLidos'])) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve ler os instrumentos legais. Após isso selecione a opção acima")]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (!_vm._.isEmpty(_vm.proposta)) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.anexos = !_vm.mostrar.anexos
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.anexos ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              Anexos\n            ")])])]), _vm._v(" "), (_vm.mostrar.anexos) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal col-md-12"
  }, [_c('upload-documentos-online', {
    attrs: {
      "idProcesso": _vm.id,
      "propDocumentos": _vm.solicitacao.anexos,
      "documentTypes": '',
      "ehVisualizacao": _vm.ehVisualizacao,
      "secaoOrigem": 'ALTERACOES_PROJETO',
      "local-uso": _vm.etapa === 'Deliberação' ? 'ALTERACOES_PROJETOS_NT_SML' : (_vm.etapa === 'Pendências' ? 'ALTERACOES_PROJETOS_ADT_PLT' : 'ALTERACOES_PROJETOS_ANEXOS'),
      "vigencia-obrigatoria": [2, 6, 40, 67],
      "docs-informa-vencimento": [2, 6, 40, 67]
    },
    on: {
      "arquivoAnexado": function($event) {
        return _vm.solicitacao.anexos.push($event)
      },
      "arquivoExcluido": function($event) {
        return _vm._.remove(_vm.solicitacao.anexos, ['id', $event.id])
      },
      "layoutAtual": function($event) {},
      "acaoSalvar": function($event) {
        return _vm.processarSolicitacao('SALVAR')
      },
      "acaoOk": function($event) {},
      "acaoCancelar": function($event) {},
      "acaoProcessamento": function($event) {
        _vm.loading.tela = true
      },
      "acaoAguardando": function($event) {
        _vm.loading.tela = false
      }
    }
  })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.etapa !== 'Solicitação') ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.historicos.tarefas = !_vm.mostrar.historicos.tarefas
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.historicos.tarefas ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Históricos tarefas")])]), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO') ? _c('span', {
    staticClass: "bloco_resumo_alteracao"
  }, [_c('div', {
    staticClass: "btn-group dropdown"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticStyle: {
      "border": "0",
      "background": "transparent"
    },
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Modo " + _vm._s(_vm._.get(this.opcoesVisualizacao, 'historico.modo', 'PADRAO') === 'PADRAO' ? 'Padrão' : 'Completo') + " "), _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.filtrarHistoricoPorModo('PADRAO')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" Padrão")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.filtrarHistoricoPorModo('COMPLETO')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(" Completo")])])])])])]) : _vm._e()]), _vm._v(" "), (_vm.mostrar.historicos.tarefas) ? _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    ref: "historico_solicitacao",
    staticClass: "table table-condensed table-bordered"
  }, [_vm._m(5), _vm._v(" "), _c('tbody', {}, _vm._l((_vm.tarefas), function(tarefa) {
    return (_vm._.get(tarefa, 'mostrar', true)) ? _c('tr', {
      class: _vm._.includes(['INCLUSAO_DOCUMENTO', 'EXCLUSAO_DOCUMENTO', 'RecPrv_at_com_senior_g5_co_mfi_prj_recursosprevistosgrid', 'INSERINDO_RECURSOS_SAPIENS', 'VISUALIZACAO'], tarefa.nome) ? 'text-muted' : (_vm._.get(_vm.opcoesVisualizacao, 'historico.modo', 'PADRAO') === 'PADRAO' ? '' : 'bg-gray-light')
    }, [_c('td', {
      staticClass: "col-md-2"
    }, [_vm._v(_vm._s(_vm._.get(_vm.tarefaNome, tarefa.nome, '!')))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-2 text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(tarefa.termino, 'DD/MM/YYYY HH:MM')))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-3 truncar",
      staticStyle: {
        "width": "100px"
      }
    }, [_vm._v(_vm._s(tarefa.ds_nome_usuario))]), _vm._v(" "), _c('td', {
      staticClass: "col-md-5"
    }, [_vm._v(_vm._s(tarefa.observacao))])]) : _vm._e()
  }), 0)])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.isEmpty(_vm.proposta) && _vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', [_c('div', {
    staticClass: "row box-header",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.sumula = !_vm.mostrar.sumula
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.sumula ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Mostrar Súmula")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mostrar.sumula),
      expression: "mostrar.sumula"
    }],
    staticClass: "form-horizontal"
  }, [_c('sumula', {
    attrs: {
      "id-processo": _vm.id,
      "props-proposta": _vm.proposta,
      "props-solicitacao": _vm.solicitacao
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.isEmpty(_vm.proposta) && !_vm._.isNull(_vm.id) && _vm._.includes(['Pendências'], _vm.etapa) && _vm._.find(_vm.solicitacao.sumula.providencias, function(p) {
    return _vm._.includes(['PLT', 'ADT'], p.codigo)
  })) ? _c('div', [_c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela || _vm.loading.aditivo.conteudo),
      expression: "loading.tela || loading.aditivo.conteudo"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "grupoMostrarOcultar",
    on: {
      "click": function($event) {
        _vm.mostrar.aditivo = !_vm.mostrar.aditivo
      }
    }
  }, [_c('i', {
    class: 'fa fa-caret-' + (_vm.mostrar.aditivo ? 'up' : 'down'),
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n              " + _vm._s(_vm._.join(_vm._.map(_vm._.filter(_vm.solicitacao.sumula.providencias, function(p) {
    return _vm._.includes(['PLT', 'ADT'], p.codigo)
  }), 'descricao'), ' e ')) + "\n            ")])])]), _vm._v(" "), (_vm.mostrar.aditivo) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "col-md-12 form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Modelo de minuta:")]), _vm._v(" "), _c('div', {
    ref: "lista aditivo",
    staticClass: "col-md-6"
  }, [(_vm.loading.aditivo.lista) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando lista com modelos de minutas disponíveis...")]) : _c('span', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaMinutasAditivo,
      "multiple": false,
      "close-on-select": true,
      "placeholder": 'Selecione um modelo de minuta dentre os disponíveis',
      "track-by": "id",
      "custom-label": function (option) {
        return ("" + (option.nome))
      },
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "name": "lista aditivo",
      "disabled": _vm.ehVisualizacao
    },
    on: {
      "select": function($event) {
        return _vm.verificaSeHaAditivoUsando($event)
      }
    },
    model: {
      value: (_vm.solicitacao.aditivo.modelo),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.aditivo, "modelo", $$v)
      },
      expression: "solicitacao.aditivo.modelo"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("Nenhum registro localizado!")])])]), _vm._v(" "), (_vm.errors.first('lista aditivo')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar um modelo de minuta")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(!_vm.loading.aditivo.lista) ? _c('g-button-moema', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    attrs: {
      "color": "warning",
      "title": '<h5>Salva a minuta atual e abre ela para impressão em nova guia</h5>'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processarSolicitacao('SALVAR', 'aditivo')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Visualizar Minuta")]) : _vm._e(), _vm._v(" "), _c('g-button-moema', {
    staticClass: "pull-right",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processarSolicitacao('SALVAR', 'plano-trabalho')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Plano de Trabalho")])], 1)]), _vm._v(" "), (!_vm._.isEmpty(_vm.solicitacao.aditivo.modelo)) ? _c('div', {
    staticClass: "col-md-12 form-group"
  }, [(_vm.loading.aditivo.conteudo) ? _c('div', {
    staticClass: "col-md-12 etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando modelo do documento...")]) : _c('div', {
    ref: 'refQuillEditor_' + _vm.quillOptions.theme,
    staticClass: "col-md-11",
    attrs: {
      "id": "modeloMinutaEdicao"
    }
  }, [_c('quill-editor', {
    attrs: {
      "disabled": _vm.ehVisualizacao,
      "theme": _vm.barra,
      "options": _vm.quillOptions
    },
    model: {
      value: (_vm.solicitacao.aditivo.conteudo),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.aditivo, "conteudo", $$v)
      },
      expression: "solicitacao.aditivo.conteudo"
    }
  })], 1)]) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm._.isEmpty(_vm.proposta) && _vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa) && !_vm.ehVisualizacao) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 form-horizontal"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.tela),
      expression: "loading.tela"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "block"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]), _vm._v(" "), _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.etapa === 'Análise' ? 'Análise da Proposta' : 'Decisão') + "\n              "), (_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('span', {
    staticStyle: {
      "margin-left": "30px",
      "height": "0"
    }
  }, [_c('g-button-moema', {
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.processarSolicitacao('SALVAR', 'sumula')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-external-link",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Súmula")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required col-md-12"
  }, [_c('div', {
    ref: "decisão",
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.encaminhamento),
      expression: "decisao.encaminhamento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": _vm.etapa === 'Análise' ? 'AUTORIZACAO' : (
        _vm.etapa === 'Autorização' ?
        (_vm.solicitacao.sumula.alcada.codigo === 'DIRETOR_OU_GER_SOLUCOES' ?
          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : 'DELIBERACAO') : (
          _vm.etapa === 'Deliberação' ?
          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : (
            _vm.etapa === 'Pendências' ? 'CONCLUSAO' : ''))),
      "checked": _vm._q(_vm.decisao.encaminhamento, _vm.etapa === 'Análise' ? 'AUTORIZACAO' : (
        _vm.etapa === 'Autorização' ?
        (_vm.solicitacao.sumula.alcada.codigo === 'DIRETOR_OU_GER_SOLUCOES' ?
          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : 'DELIBERACAO') : (
          _vm.etapa === 'Deliberação' ?
          (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : (
            _vm.etapa === 'Pendências' ? 'CONCLUSAO' : ''))))
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.decisao, "encaminhamento", _vm.etapa === 'Análise' ? 'AUTORIZACAO' : (
          _vm.etapa === 'Autorização' ?
          (_vm.solicitacao.sumula.alcada.codigo === 'DIRETOR_OU_GER_SOLUCOES' ?
            (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : 'DELIBERACAO') : (
            _vm.etapa === 'Deliberação' ?
            (_vm.solicitacao.sumula.providencias.length > 0 ? 'PENDENCIAS' : 'CONCLUSAO') : (
              _vm.etapa === 'Pendências' ? 'CONCLUSAO' : ''))))
      }
    }
  }), _vm._v("\n                         " + _vm._s(_vm.etapa === 'Análise' ? 'Registro de Parecer' : 'Aprovar') + "\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  }), _vm._v(" "), (_vm._.includes(['DELIBERACAO', 'PENDENCIAS', 'CONCLUSAO'], _vm.decisao.encaminhamento)) ? _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [(_vm._.includes(['CONCLUSAO'], _vm.decisao.encaminhamento)) ? _c('span', [_vm._v(" (concluir e finalizar o processo)")]) : _c('span', [_vm._v(" (encaminhar para " + _vm._s(_vm.tarefaNome[_vm.decisao.encaminhamento]) + ")")])]) : _vm._e()]), _vm._v(" "), (_vm.decisao.encaminhamento === 'PENDENCIAS' || _vm.decisao.encaminhamento === 'DELIBERACAO') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_aprovacao"
    }
  }, [_vm._v("Observação Opcional:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.observacao),
      expression: "decisao.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_aprovacao",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.decisao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.decisao, "observacao", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), ((_vm.etapa === 'Análise' && _vm.decisao.encaminhamento === 'AUTORIZACAO')) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "sumula_formulario"
  }, [_vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
    return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
  })), function(pergunta, idx) {
    return _c('tr', {
      staticClass: "sumula_pergunta"
    }, [_c('td', {
      staticClass: "sumula_codigo"
    }, [_vm._v(_vm._s(idx + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sumula_questao"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(pergunta.questao)
      }
    }), _vm._v(" "), (!_vm.loading.ocorrencias && _vm._.includes(['Q005'], pergunta.codigo)) ? _c('span', {
      staticClass: "link_acesso pad10",
      on: {
        "click": function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo], 'ATUALIZA_CONSULTA')
        }
      }
    }, [_vm._v("atualiza!")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "sumula_resposta"
    }, [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pergunta.resposta),
        expression: "pergunta.resposta"
      }],
      attrs: {
        "value": "sim",
        "type": "radio",
        "name": 'respostaSumulaQuestao' + pergunta.codigo
      },
      domProps: {
        "checked": _vm._q(pergunta.resposta, "sim")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(pergunta, "resposta", "sim")
        }, function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo])
        }]
      }
    }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pergunta.resposta),
        expression: "pergunta.resposta"
      }],
      attrs: {
        "value": "nao",
        "type": "radio",
        "name": 'respostaSumulaQuestao' + pergunta.codigo
      },
      domProps: {
        "checked": _vm._q(pergunta.resposta, "nao")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(pergunta, "resposta", "nao")
        }, function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo])
        }]
      }
    }), _vm._v(" Não")]), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pergunta.resposta),
        expression: "pergunta.resposta"
      }],
      attrs: {
        "value": "pre",
        "type": "radio",
        "name": 'respostaSumulaQuestao' + pergunta.codigo
      },
      domProps: {
        "checked": _vm._q(pergunta.resposta, "pre")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(pergunta, "resposta", "pre")
        }, function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo])
        }]
      }
    }), _vm._v(" Prej.")])])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "sumula_cabecalho_questoes"
  }, [_c('td', {
    staticClass: "sumula_codigo"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('td', {
    ref: "parceriaEstrategica",
    staticClass: "sumula_resposta"
  }, [_c('span', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('parceriaEstrategica')
    }
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.parceriaEstrategica),
      expression: "solicitacao.sumula.parceriaEstrategica"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": "sim",
      "type": "radio",
      "name": "parceriaEstrategica"
    },
    domProps: {
      "checked": _vm._q(_vm.solicitacao.sumula.parceriaEstrategica, "sim")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.solicitacao.sumula, "parceriaEstrategica", "sim")
      }
    }
  }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.parceriaEstrategica),
      expression: "solicitacao.sumula.parceriaEstrategica"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": "nao",
      "type": "radio",
      "name": "parceriaEstrategica"
    },
    domProps: {
      "checked": _vm._q(_vm.solicitacao.sumula.parceriaEstrategica, "nao")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.solicitacao.sumula, "parceriaEstrategica", "nao")
      }
    }
  }), _vm._v(" Não")])]), _vm._v(" "), (_vm.errors.first('parceriaEstrategica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Selecione uma opção")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
    return _vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
  })), function(pergunta, idx) {
    return (_vm.solicitacao.sumula.parceriaEstrategica === 'sim') ? _c('tr', {
      staticClass: "sumula_pergunta"
    }, [_c('td', {
      staticClass: "sumula_codigo"
    }, [_vm._v(_vm._s(idx + (_vm._.filter(_vm.solicitacao.sumula.questionario, function(q) {
      return !_vm._.includes(['Q011', 'Q012', 'Q013', 'Q014'], q.codigo)
    })).length + 1))]), _vm._v(" "), _c('td', {
      staticClass: "sumula_questao",
      domProps: {
        "innerHTML": _vm._s(pergunta.questao)
      }
    }), _vm._v(" "), _c('td', {
      staticClass: "sumula_resposta"
    }, [_c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pergunta.resposta),
        expression: "pergunta.resposta"
      }],
      attrs: {
        "value": "sim",
        "type": "radio",
        "name": 'respostaSumulaQuestao' + pergunta.codigo
      },
      domProps: {
        "checked": _vm._q(pergunta.resposta, "sim")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(pergunta, "resposta", "sim")
        }, function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo])
        }]
      }
    }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pergunta.resposta),
        expression: "pergunta.resposta"
      }],
      attrs: {
        "value": "nao",
        "type": "radio",
        "name": 'respostaSumulaQuestao' + pergunta.codigo
      },
      domProps: {
        "checked": _vm._q(pergunta.resposta, "nao")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(pergunta, "resposta", "nao")
        }, function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo])
        }]
      }
    }), _vm._v(" Não")]), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (pergunta.resposta),
        expression: "pergunta.resposta"
      }],
      attrs: {
        "value": "pre",
        "type": "radio",
        "name": 'respostaSumulaQuestao' + pergunta.codigo
      },
      domProps: {
        "checked": _vm._q(pergunta.resposta, "pre")
      },
      on: {
        "change": [function($event) {
          return _vm.$set(pergunta, "resposta", "pre")
        }, function($event) {
          return _vm.executarRegrasQuestoes([pergunta.codigo])
        }]
      }
    }), _vm._v(" Prej.")])])]) : _vm._e()
  }), _vm._v(" "), _c('tr', {
    staticClass: "sumula_cabecalho_questoes"
  }, [_c('td', {
    staticClass: "sumula_codigo"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('td', {
    ref: "ajusteQuantidade",
    staticClass: "sumula_resposta"
  }, [_c('span', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('parceriaEstrategica')
    }
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade),
      expression: "solicitacao.sumula.resumoAlteracoes.ajusteQuantidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": "1",
      "type": "radio",
      "name": "ajusteQuantidade"
    },
    domProps: {
      "checked": _vm._q(_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade, "1")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "ajusteQuantidade", "1")
      }
    }
  }), _vm._v(" Sim")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade),
      expression: "solicitacao.sumula.resumoAlteracoes.ajusteQuantidade"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "value": "0",
      "type": "radio",
      "name": "ajusteQuantidade"
    },
    domProps: {
      "checked": _vm._q(_vm.solicitacao.sumula.resumoAlteracoes.ajusteQuantidade, "0")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "ajusteQuantidade", "0")
      }
    }
  }), _vm._v(" Não")])]), _vm._v(" "), (_vm.errors.first('ajusteQuantidade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Indique se houve esse ajuste")]) : _vm._e()])]), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, [_vm.nome, 'REMANEJAMENTO'])) ? _c('tr', {
    staticClass: "sumula_cabecalho_questoes"
  }, [_c('td', {
    staticClass: "sumula_codigo"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('td', {
    ref: "percentualRemanejamentosConcedidos",
    staticClass: "sumula_resposta"
  }, [_c('span', {
    staticClass: "indicadores-cb-inline",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "required-field",
    class: {
      'has-error': _vm.errors.first('percentualRemanejamentosConcedidos')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos),
      expression: "solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:0|max:100'),
      expression: "'required|min:0|max:100'"
    }],
    staticClass: "form-control",
    attrs: {
      "value": "0",
      "type": "number",
      "name": "percentualRemanejamentosConcedidos",
      "min": "0",
      "max": "100"
    },
    domProps: {
      "value": (_vm.solicitacao.sumula.resumoAlteracoes.percentualRemanejamentosConcedidos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "percentualRemanejamentosConcedidos", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.errors.first('percentualRemanejamentosConcedidos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Percentual deve estar entre 0 e 100")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm._.find(_vm.solicitacao.processos, [_vm.nome, 'SUPLEMENTACAO'])) ? _c('tr', {
    staticClass: "sumula_cabecalho_questoes"
  }, [_c('td', {
    staticClass: "sumula_codigo"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('td', {
    ref: "enquadramentoOrcamentarioFEP",
    staticClass: "sumula_resposta"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP),
      expression: "solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP"
    }],
    staticClass: "form-control",
    attrs: {
      "value": "0",
      "type": "number",
      "name": "enquadramentoOrcamentarioFEP"
    },
    domProps: {
      "value": (_vm.solicitacao.sumula.resumoAlteracoes.enquadramentoOrcamentarioFEP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "enquadramentoOrcamentarioFEP", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('tr', {
    staticClass: "sumula_cabecalho_questoes"
  }, [_c('td', {
    staticClass: "sumula_codigo"
  }, [_vm._v(" ")]), _vm._v(" "), _c('td', {
    staticClass: "sumula_questao",
    attrs: {
      "colspan": "2"
    }
  }, [_c('label', {
    staticClass: "control-label pull-left"
  }, [_vm._v("Outras alterações")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "width": "80%",
      "margin-right": "-10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.solicitacao.sumula.resumoAlteracoes.outrasAlteracoes),
      expression: "solicitacao.sumula.resumoAlteracoes.outrasAlteracoes"
    }],
    staticClass: "form-control",
    attrs: {
      "value": "",
      "type": "text",
      "name": "outrasAlteracoes"
    },
    domProps: {
      "value": (_vm.solicitacao.sumula.resumoAlteracoes.outrasAlteracoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.solicitacao.sumula.resumoAlteracoes, "outrasAlteracoes", $event.target.value)
      }
    }
  })])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    ref: "sumula_contexto",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('sumula_contexto')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Contexto:")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'Informe o Contexto da análise ref. este ID ' + _vm.id,
      "min-height": 72,
      "autosize": true,
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
      "name": "sumula_contexto",
      "rows": "3"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.solicitacao.sumula.textoContexto),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.sumula, "textoContexto", $$v)
      },
      expression: "solicitacao.sumula.textoContexto"
    }
  }), _vm._v(" "), (_vm.errors.first('sumula_contexto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Informe o contexto da análise")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "sumula_situacao_problema",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('sumula_situacao_problema')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Situação Problema:")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'Informe a Situação Problema que será analisada ref. este ID ' + _vm.id,
      "min-height": 72,
      "autosize": true,
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
      "name": "sumula_situacao_problema",
      "rows": "3"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.solicitacao.sumula.textoSituacaoProblema),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.sumula, "textoSituacaoProblema", $$v)
      },
      expression: "solicitacao.sumula.textoSituacaoProblema"
    }
  }), _vm._v(" "), (_vm.errors.first('sumula_situacao_problema')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Descreva a situação problema para esta solicitação")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "sumula_parecer",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('sumula_parecer')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Parecer:")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'Informe o Parecer para deliberação ref. este ID ' + _vm.id,
      "min-height": 72,
      "autosize": true,
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
      "name": "sumula_parecer",
      "rows": "3"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.solicitacao.sumula.textoParecer),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.sumula, "textoParecer", $$v)
      },
      expression: "solicitacao.sumula.textoParecer"
    }
  }), _vm._v(" "), (_vm.errors.first('sumula_parecer')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Informe o parecer desta análise")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "sumula_proposta",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('sumula_proposta')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Proposta:")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'Informe sua proposta para deliberação ref. este ID ' + _vm.id,
      "min-height": 72,
      "autosize": true,
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise',
      "name": "sumula_proposta",
      "rows": "3"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.solicitacao.sumula.textoProposta),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.sumula, "textoProposta", $$v)
      },
      expression: "solicitacao.sumula.textoProposta"
    }
  }), _vm._v(" "), (_vm.errors.first('sumula_proposta')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Informe a proposta para a solicitação")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    ref: "providencias",
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Providências:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.listaProvidencias,
      "multiple": true,
      "close-on-select": false,
      "placeholder": 'Selecione uma ou mais providências para efetivação desta solicitação ID ' + _vm.id,
      "track-by": "codigo",
      "custom-label": function (option) {
        return ("" + (option.descricao))
      },
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "providencias",
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
    },
    model: {
      value: (_vm.solicitacao.sumula.providencias),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.sumula, "providencias", $$v)
      },
      expression: "solicitacao.sumula.providencias"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("Nenhum registro localizado!")])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    ref: "alcada",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('alcada')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Alçada:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listaAlcadas,
      "multiple": false,
      "close-on-select": true,
      "placeholder": 'Selecione a alçada para esta solicitação ID ' + _vm.id,
      "track-by": "codigo",
      "custom-label": function (option) {
        return ("" + (option.descricao))
      },
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "alcada",
      "disabled": _vm.ehVisualizacao || _vm.etapa !== 'Análise'
    },
    model: {
      value: (_vm.solicitacao.sumula.alcada),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao.sumula, "alcada", $$v)
      },
      expression: "solicitacao.sumula.alcada"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("Nenhum registro localizado!")])])]), _vm._v(" "), (_vm.errors.first('alcada')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar a alçada")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    ref: "motivo alteracao",
    staticClass: "col-md-12 required-field",
    class: {
      'has-error': _vm.errors.first('motivo alteracao')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-2"
  }, [_vm._v("Motivo:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.loading.motivosSolicitacao) ? _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando lista de motivos para este conjunto de alterações...")]) : _c('span', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.motivosSolicitacao,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": true,
      "hide-selected": false,
      "preserve-search": true,
      "placeholder": 'Selecione um enquadramento para as alterações dessa solicitação ID ' + _vm.id,
      "track-by": "codigo",
      "custom-label": function (option) {
        return ("" + (option.descricao))
      },
      "preselect-first": false,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "Selecionado",
      "name": "motivo alteracao",
      "data-vv-as": "Motivo da alteração",
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.solicitacao.motivoAlteracao),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao, "motivoAlteracao", $$v)
      },
      expression: "solicitacao.motivoAlteracao"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("Nenhum registro localizado!")])])]), _vm._v(" "), (_vm.errors.first('motivo alteracao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" Deve selecionar um motivo para este conjunto de alterações")]) : _vm._e()], 1)])])]) : _vm._e(), _vm._v(" "), ((_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa) && _vm.decisao.encaminhamento === 'CONCLUSAO')) ? _c('div', {
    staticClass: "form-group col-md-12"
  }, [(_vm._.includes(['Análise', 'Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        inertia: true,
        arrow: true,
        animation: 'perspective',
        distance: '1',
        size: 'large'
      }),
      expression: "{inertia:true, arrow:true, animation:'perspective', distance:'1', size:'large'}"
    }],
    staticClass: "control-label",
    attrs: {
      "title": '<h5>Observação opcional. Algo escrito aqui ficará no histórico público do processo</h5>'
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle text-muted"
  }), _vm._v(" Observação:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.observacao),
      expression: "decisao.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "observacao_decisao",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.decisao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.decisao, "observacao", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm._.includes(['Pendências'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.encaminhamento),
      expression: "decisao.encaminhamento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "AUTORIZACAO",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.decisao.encaminhamento, "AUTORIZACAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.decisao, "encaminhamento", "AUTORIZACAO")
      }
    }
  }), _vm._v(" " + _vm._s('Devolver para autorização') + "\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]) : _vm._e(), _vm._v(" "), (_vm._.includes(['Autorização', 'Deliberação', 'Pendências'], _vm.etapa)) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.encaminhamento),
      expression: "decisao.encaminhamento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "ANALISE",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.decisao.encaminhamento, "ANALISE")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.decisao, "encaminhamento", "ANALISE")
      }
    }
  }), _vm._v(" " + _vm._s('Devolver para ajuste do analista') + "\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.decisao.encaminhamento === 'ANALISE') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa reanalise')
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa_reanalise"
    }
  }, [_vm._v("Motivo para reanalisar:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.observacao),
      expression: "decisao.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "justificativa reanalise",
      "rows": "3",
      "id": "justificativa_reanalise",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.decisao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.decisao, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa reanalise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa reanalise')))]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.etapa === 'Análise') ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "new-control new-control-radio",
    staticStyle: {
      "padding-top": "8px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.encaminhamento),
      expression: "decisao.encaminhamento"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "decisão",
      "value": "REVISAO",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "checked": _vm._q(_vm.decisao.encaminhamento, "REVISAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.decisao, "encaminhamento", "REVISAO")
      }
    }
  }), _vm._v(" Devolver para revisão da entidade\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-12"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.decisao.encaminhamento === 'REVISAO') ? _c('div', {
    ref: "motivo de devolucao",
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('motivo de devolucao')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Motivo de devolução:")]), _vm._v(" "), _c('div', [_c('multiselect', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.listMotivosDevolucao,
      "multiple": true,
      "close-on-select": true,
      "placeholder": "Selecione um ou mais motivos para Devolução da solicitação à entidade",
      "custom-label": function (option) {
        return ("" + (option.descricao))
      },
      "track-by": "codigo",
      "selectedLabel": "Selecionado",
      "selectLabel": "Aperte ENTER para selecionar",
      "deselectLabel": "Aperte ENTER para remover",
      "name": "motivo de devolucao",
      "data-vv-as": "motivo de devolucao",
      "option-height": 30,
      "disabled": _vm.ehVisualizacao
    },
    model: {
      value: (_vm.solicitacao.motivosDevolucao),
      callback: function($$v) {
        _vm.$set(_vm.solicitacao, "motivosDevolucao", $$v)
      },
      expression: "solicitacao.motivosDevolucao"
    }
  })], 1), _vm._v(" "), (_vm.errors.first('motivo de devolucao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo de devolucao')))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.decisao.encaminhamento === 'REVISAO') ? _c('div', {
    staticClass: "required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('justificativa')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Observação para revisão:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.decisao.observacao),
      expression: "decisao.observacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "motivo para revisão",
    staticClass: "form-control",
    attrs: {
      "name": "motivo para revisão",
      "rows": "3",
      "disabled": _vm.ehVisualizacao
    },
    domProps: {
      "value": (_vm.decisao.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.decisao, "observacao", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('motivo para revisão')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('motivo para revisão')))]) : _vm._e()]) : _vm._e()])])]) : _vm._e()])])])])])])])]) : _vm._e()]), _vm._v(" "), _c('dialog', {
    ref: "alertaCancelamentoDialog",
    attrs: {
      "id": "alertaCancelamentoDialog"
    }
  }, [_vm._m(11), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "25px 0"
    }
  }, [_vm._v("\n      Confirma o cancelamento da solicitação de alteração?\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      Justificativa (obrigatório)\n    ")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.justificativaCancelamento),
      expression: "justificativaCancelamento"
    }],
    staticStyle: {
      "width": "100%",
      "border": "none",
      "padding": "10px",
      "margin": "0 0 10px 0",
      "color": "#222"
    },
    attrs: {
      "type": "text",
      "placeholder": "Escreva a justificativa (min. 10 caracteres)"
    },
    domProps: {
      "value": (_vm.justificativaCancelamento)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.justificativaCancelamento = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-neutral",
    staticStyle: {
      "margin": "0 10px"
    },
    attrs: {
      "onclick": "alertaCancelamentoDialog.close()"
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.justificativaCancelamento.length < 10
    },
    on: {
      "click": function($event) {
        return _vm.cancelarProcesso()
      }
    }
  }, [_vm._v("Sim, cancelar o processo")])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Alerta!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "etiquetaCarregando"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" Carregando histórico de alterações em períodos de execução do projeto...")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v(" Atenção!")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {}, [_c('tr', [_c('th', [_vm._v("Etapa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "text-align": "center",
      "width": "120px"
    }
  }, [_vm._v("Data")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Usuário")]), _vm._v(" "), _c('th', [_vm._v("Observação")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sumula_questao"
  }, [_c('label', [_vm._v("Parceria Estratégica?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sumula_questao"
  }, [_c('label', [_vm._v("Houve ajustes nas quantidades dos itens de despesa?")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sumula_questao"
  }, [_c('label', [_vm._v("Percentual dos Remanejamentos Concedidos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "sumula_questao"
  }, [_c('label', [_vm._v("Enquadramento orçamentário (FEP)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('h4', {
    staticClass: "box-title"
  }, [_vm._v(" Análise:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Atenção!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17be9dd8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/alteracoesProjeto/EditaProjeto.vue
// module id = 1777
// module chunks = 2